import React from "react"
import { combineReducers } from "redux"
import { toast } from "react-toastify"
import _ from "lodash"
import * as actionTypes from "../actions/types"

const toastOptions = {
  toastId: "user-details-page",
  containerId: "main"
}

function requestUserState(state = false, action) {
  switch (action.type) {
    case actionTypes.USER_REQUEST_START:
      return true
    case actionTypes.USER_REQUEST_SUCCESS:
    case actionTypes.USER_REQUEST_FAILURE:
      return false
    default:
      return state
  }
}

function postUserState(state = false, action) {
  switch (action.type) {
    case actionTypes.USER_POST_START:
      return true
    case actionTypes.USER_POST_SUCCESS:
      toast.success(
        <div>
          <span role="img" aria-label="success-icon">✅</span>
          <span className="ml-2">User updated!</span>
        </div>,
        toastOptions
      )
      return false
    case actionTypes.USER_POST_FAILURE:
      toast.error(
        <div>
          <span role="img" aria-label="failure-icon">❌</span>
          <span className="ml-2">User update error!</span>
        </div>,
        toastOptions
      )
      return false
    default:
      return state
  }
}

function requestSurveyorSkillsState(state = false, action) {
  switch (action.type) {
    case actionTypes.SURVEYOR_SKILL_REQUEST_START:
      return true
    case actionTypes.SURVEYOR_SKILL_REQUEST_SUCCESS:
    case actionTypes.SURVEYOR_SKILL_REQUEST_FAILURE:
      return false
    default:
      return state
  }
}

function editState(state = false, action) {
  switch (action.type) {
    case actionTypes.MANAGE_USERS_START_EDITING:
      return true
    case actionTypes.MANAGE_USERS_EDIT_RESET:
    case actionTypes.MANAGE_USERS_EDIT_SAVE:
    case actionTypes.MANAGE_USERS_EDIT_CANCEL:
      return false
    default:
      return state
  }
}

// Helper function to extract user attributes from different action structures
function extractUserAttributes(action, actionType) {
  let userAttributes = {}
  switch (actionType) {
    case actionTypes.USER_REQUEST_SUCCESS:
    case actionTypes.USER_POST_SUCCESS:
      userAttributes = _.get(Object.values(action.data.user), "0.attributes", {})
      break
    case actionTypes.MANAGE_USERS_EDIT_CANCEL:
      userAttributes = _.get(action.data, "attributes", {})
      break
    default:
      return {}
  }

  const getAttr = (key, snakeKey) => {
    const val = userAttributes[key]
    return val !== undefined ? val : userAttributes[snakeKey]
  }

  const {
    email, phone, role,
    monday, tuesday, wednesday, thursday, friday, saturday, sunday
  } = userAttributes

  return {
    firstname: getAttr("firstname", "first_name"),
    surname: getAttr("surname", "last_name") || getAttr("surname", "surname"),
    email,
    phone,
    role,
    fulladdress: getAttr("fulladdress", "full_address"),
    emergency_contact: getAttr("emergencyContact", "emergency_contact"),
    emergency_contact_number: getAttr("emergencyContactNumber", "emergency_contact_number"),
    surveyor_type: getAttr("surveyorType", "surveyor_type"),
    surveyor_id: getAttr("surveyorId", "surveyor_id"),
    hourly_rate: getAttr("hourlyRate", "hourly_rate"),
    surveyor_goals_enabled: getAttr("surveyorGoalsEnabled", "surveyor_goals_enabled"),
    surveyor_skills_ids: getAttr("surveyorSkillsIds", "surveyor_skills_ids"),
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
    monday_start_time: getAttr("mondayStartTime", "monday_start_time"),
    monday_finish_time: getAttr("mondayFinishTime", "monday_finish_time"),
    tuesday_start_time: getAttr("tuesdayStartTime", "tuesday_start_time"),
    tuesday_finish_time: getAttr("tuesdayFinishTime", "tuesday_finish_time"),
    wednesday_start_time: getAttr("wednesdayStartTime", "wednesday_start_time"),
    wednesday_finish_time: getAttr("wednesdayFinishTime", "wednesday_finish_time"),
    thursday_start_time: getAttr("thursdayStartTime", "thursday_start_time"),
    thursday_finish_time: getAttr("thursdayFinishTime", "thursday_finish_time"),
    friday_start_time: getAttr("fridayStartTime", "friday_start_time"),
    friday_finish_time: getAttr("fridayFinishTime", "friday_finish_time"),
    saturday_start_time: getAttr("saturdayStartTime", "saturday_start_time"),
    saturday_finish_time: getAttr("saturdayFinishTime", "saturday_finish_time"),
    sunday_start_time: getAttr("sundayStartTime", "sunday_start_time"),
    sunday_finish_time: getAttr("sundayFinishTime", "sunday_finish_time")
  }
}

function userEditableAttr(state = {}, action) {
  switch (action.type) {
    case actionTypes.USER_REQUEST_SUCCESS:
      return extractUserAttributes(action, action.type)
    case actionTypes.USER_POST_SUCCESS: {
      const attributes = extractUserAttributes(action, action.type)
      const cleanAttributes = _.pickBy(attributes, v => v !== undefined)
      return { ...state, ...cleanAttributes }
    }
    case actionTypes.MANAGE_USERS_EDIT_CANCEL:
      return extractUserAttributes(action, action.type)
    case actionTypes.MANAGE_USERS_EDIT_UPDATE:
      return { ...state, ...action.data }
    default:
      return state
  }
}

export default combineReducers({
  requestUserState,
  requestSurveyorSkillsState,
  postUserState,
  editState,
  userEditableAttr
})